import React from 'react';
export default {
  fonts: [
    'Arial',
    'OpenSans',
    'Courier',
    'Helvetica',
    'Times New Roman',
    'Roboto',
    'Lato',
    'Lora',
    'Calibri'
  ].map(f => ({ value: f, label: f })),
  applicationTypes: [
    { label: 'Initiativbewerbung', value: 'initiativ' },
    { label: 'Stellenanzeige', value: 'stellenanzeige' }
  ],
  contactPersonRoles: [
    { label: 'Chefärzt:in', value: 'chefarzt' },
    { label: 'Oberärzt:in', value: 'oberarzt' },
    { label: 'Personalbeauftragte:r', value: 'personaler' },
    { label: 'Personalbeauftragte:r', value: 'personaler' },
    { label: 'Sekretariat Chefärzt:in', value: 'sekretariat_chefarzt' },
    { label: 'Sekretariat Personal', value: 'sekretariat_personal' },
    { label: 'Kein Ansprechpartner', value: 'no_contact_person' }
  ],
  documentTypes: [
    {
      name: 'Anschreiben',
      headline: 'Anschreiben',
      description: null,
      required: true,
      maxFiles: 100,
      hide: true
    },
    {
      name: 'Deckblatt',
      headline: 'Deckblatt',
      description: null,
      required: false,
      maxFiles: 100,
      hide: true
    },
    {
      name: 'Lebenslauf-Foto',
      headline: 'Lebenslauf-Foto',
      description: null,
      required: false,
      maxFiles: 1,
      hide: true,
      allowed: ['.jpeg', '.png', '.jpg']
    },
    {
      name: 'Unterschrift',
      headline: 'Unterschrift',
      description: null,
      required: false,
      maxFiles: 1,
      hide: true,
      allowed: ['.jpeg', '.png', '.jpg']
    },
    {
      name: 'Lebenslauf',
      headline: 'Lebenslauf',
      description: null,
      required: true,
      maxFiles: 1
    },
    {
      name: 'Approbationsurkunde',
      headline: 'Approbationsurkunde',
      description: 'Wenn du deine Approbationsurkunde schon hast, kannst du sie hier hochladen. Das wäre empfehlenswert. Wenn nicht, reichen erst einmal die Zeugnisse der Examina.',
      required: false,
      maxFiles: 1
    },
    {
      name: 'Zeugnisse der Examina',
      headline: 'Zeugnisse der Examina',
      description: 'Hier kannst du alle Zeugnisse hochladen, die du im Laufe deines Studiums für Examina erhalten hast.',
      required: true,
      maxFiles: 100
    },
    {
      name: 'Zeugnis der ärztlichen Prüfung',
      headline: 'Zeugnis der ärztlichen Prüfung',
      description: null,
      required: false,
      maxFiles: 1
    },
    {
      name: 'Ausbildungszeugnis',
      headline: 'Ausbildungszeugnis',
      description: 'Wenn du z.B. eine Ausbildung im Rettungsdienst absolviert hast, kannst du dessen Zeugnis hier hochladen.',
      required: false,
      maxFiles: 1
    },
    {
      name: 'Abiturzeugnis',
      headline: 'Abiturzeugnis',
      description: null,
      required: false,
      maxFiles: 1
    },
    {
      name: 'Empfehlungsschreiben',
      headline: 'Empfehlungsschreiben',
      description: 'Wenn du im Laufe deiner ärztlichen Karriere Empfehlungsschreiben erhalten hast, kannst du sie hier hochladen',
      required: false,
      maxFiles: 100
    },
    {
      name: 'Auslandsaufenthalte',
      headline: 'Auslandsaufenthalte',
      description: 'Wenn du Nachweise und Zeugnisse von Auslandsaufenthalten hast, kannst du sie hier hochladen.',
      required: false,
      maxFiles: 100
    },
    {
      name: 'Fachkunde- und Fortbildungsnachweise',
      headline: 'Fachkunde- und Fortbildungsnachweise',
      description: 'Hier kannst du alles hochladen, was du an Fortbildungen gemacht und Fachkundenachweisen bekommen hast.',
      required: false,
      maxFiles: 100
    },
    {
      name: 'Promotionsurkunde',
      headline: 'Promotionsurkunde',
      description: 'Wenn du bereits promoviert bist, kannst du das Zeugnis hier hochladen.',
      required: false,
      maxFiles: 1
    },
    {
      name: 'Weiteres',
      headline: 'Andere relevante Dokumente',
      description: null,
      required: false,
      maxFiles: 100
    }
  ],
  areasOfExpertise: [
    { label: 'Bitte wählen...', value: '', isDisabled: true },
    { label: 'Allgemeinmedizin', value: 'Allgemeinmedizin' },
    { label: 'Anästhesiologie', value: 'Anästhesiologie' },
    { label: 'Arbeitsmedizin', value: 'Arbeitsmedizin' },
    { label: 'Augenheilkunde', value: 'Augenheilkunde' },
    { label: 'Allgemeinchirurgie', value: 'Allgemeinchirurgie' },
    { label: 'Gefäßchirurgie', value: 'Gefäßchirurgie' },
    { label: 'Herzchirurgie', value: 'Herzchirurgie' },
    { label: 'Kinderchirurgie', value: 'Kinderchirurgie' },
    { label: 'Orthopädie und Unfallchirurgie', value: 'Orthopädie und Unfallchirurgie' },
    { label: 'Plastische und Ästhetische Chirurgie', value: 'Plastische und Ästhetische Chirurgie' },
    { label: 'Thoraxchirurgie', value: 'Thoraxchirurgie' },
    { label: 'Viszeralchirurgie', value: 'Viszeralchirurgie' },
    { label: 'Frauenheilkunde und Geburtshilfe', value: 'Frauenheilkunde und Geburtshilfe' },
    { label: 'Geriatrie', value: 'Geriatrie' },
    { label: 'Hals-Nasen-Ohrenheilkunde', value: 'Hals-Nasen-Ohrenheilkunde' },
    { label: 'Haut- und Geschlechtskrankheiten', value: 'Haut- und Geschlechtskrankheiten' },
    { label: 'Humangenetik', value: 'Humangenetik' },
    { label: 'Hygiene und Umweltmedizin', value: 'Hygiene und Umweltmedizin' },
    { label: 'Innere Medizin', value: 'Innere Medizin' },
    { label: 'Innere Medizin und Angiologie', value: 'Innere Medizin und Angiologie' },
    { label: 'Innere Medizin und Endokrinologie und Diabetologie', value: 'Innere Medizin und Endokrinologie und Diabetologie' },
    { label: 'Innere Medizin und Gastroenterologie', value: 'Innere Medizin und Gastroenterologie' },
    { label: 'Innere Medizin und Hämatologie und Onkologie', value: 'Innere Medizin und Hämatologie und Onkologie' },
    { label: 'Innere Medizin und Kardiologie', value: 'Innere Medizin und Kardiologie' },
    { label: 'Innere Medizin und Nephrologie', value: 'Innere Medizin und Nephrologie' },
    { label: 'Innere Medizin und Pneumologie', value: 'Innere Medizin und Pneumologie' },
    { label: 'Innere Medizin und Rheumatologie', value: 'Innere Medizin und Rheumatologie' },
    { label: 'Kinder- und Jugendpsychiatrie', value: 'Kinder- und Jugendpsychiatrie' },
    { label: 'Laboratoriumsmedizin', value: 'Laboratoriumsmedizin' },
    { label: 'Mikrobiologie, Virologie und Infektionsepidemiologie', value: 'Mikrobiologie, Virologie und Infektionsepidemiologie' },
    { label: 'Mund-Kiefer-Gesichtschirurgie', value: 'Mund-Kiefer-Gesichtschirurgie' },
    { label: 'Neurochirurgie', value: 'Neurochirurgie' },
    { label: 'Neurologie', value: 'Neurologie' },
    { label: 'Nuklearmedizin', value: 'Nuklearmedizin' },
    { label: 'Öffentliches Gesundheitswesen', value: 'Öffentliches Gesundheitswesen' },
    { label: 'Neuropathologie', value: 'Neuropathologie' },
    { label: 'Pathologie', value: 'Pathologie' },
    { label: 'Klinische Pharmakologie', value: 'Klinische Pharmakologie' },
    { label: 'Pharmakologie und Toxikologie', value: 'Pharmakologie und Toxikologie' },
    { label: 'Physikalische und Rehabilitative Medizin', value: 'Physikalische und Rehabilitative Medizin' },
    { label: 'Psychiatrie und Psychotherapie', value: 'Psychiatrie und Psychotherapie' },
    { label: 'Psychosomatische Medizin und Psychotherapie', value: 'Psychosomatische Medizin und Psychotherapie' },
    { label: 'Radiologie', value: 'Radiologie' },
    { label: 'Rechtsmedizin', value: 'Rechtsmedizin' },
    { label: 'Strahlentherapie', value: 'Strahlentherapie' },
    { label: 'Transfusionsmedizin', value: 'Transfusionsmedizin' },
    { label: 'Urologie', value: 'Urologie' },
    { label: 'Kinder- und Jugendmedizin', value: 'Kinder- und Jugendmedizin' },
    { label: 'Gynäkologie', value: 'Frauenheilkunde und Geburtshilfe' },
    { label: 'Dermatologie', value: 'Haut- und Geschlechtskrankheiten' },
    { label: 'Pädiatrie', value: 'Kinder- und Jugendmedizin' },
    { label: 'HNO', value: 'Hals-Nasen-Ohrenheilkunde' },
    { label: 'KJP', value: 'Kinder- und Jugendpsychiatrie' }
  ],
  cookies: [
    {
      name: 'Felix Medicus Cookie',
      id: 'fxmed-rating',
      type: 'Nutzerverhalten',
      description: 'Cookie für das Aufzeichnen des Nutzerverhaltens, um unsere Plattform weiterzuentwickeln.'
    },
    {
      name: 'Cookie für Bewertungen',
      id: 'rating',
      type: 'Nutzerinformationen',
      description: 'Cookie, der deine Daten für eine Bewertung speichert, damit du nicht immer deine Daten eingeben musst.'
    }
  ],
  clinicTypes: [
    { label: 'Hochschulklinik/Universitätsklinikum', value: 'Hochschulklinik/Universitätsklinikum' },
    { label: 'Plankrankenhaus', value: 'Plankrankenhaus' },
    { label: 'Krankenhaus mit Versorgungsvertrag', value: 'Krankenhaus mit Versorgungsvertrag' },
    { label: 'Krankenhaus ohne Versorgungsvertrag', value: 'Krankenhaus ohne Versorgungsvertrag' },
    { label: 'Bundeswehrkrankenhaus', value: 'Bundeswehrkrankenhaus' }
  ],
  clinicCarrier: [
    { label: 'öffentlich in öffentlich-rechtlicher Form, rechtlich unselbstständig', value: 'öffentlich in öffentlich-rechtlicher Form, rechtlich unselbstständig' },
    { label: 'öffentlich in öffentlich-rechtlicher Form, rechtlich selbstständig', value: 'öffentlich in öffentlich-rechtlicher Form, rechtlich selbstständig' },
    { label: 'öffentlich in privatrechtlicher Form', value: 'öffentlich in privatrechtlicher Form' },
    { label: 'freigemeinnützig', value: 'freigemeinnützig' },
    { label: 'privat', value: 'privat' }
  ],
  desireCategories: [
    { label: 'Dienste', value: 'shifts' },
    { label: 'Arbeitszeit', value: 'workingTime' },
    { label: 'Einarbeitung', value: 'training' },
    { label: 'Familie', value: 'family' },
    { label: 'Fortbildungen', value: 'courses' }
  ],
  dissertationTypes: [
    { label: 'kumulativ', value: 'kumulativ' },
    { label: 'normal', value: 'normal' }
  ],
  germanMonths: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember'
  ],
  languages: [
    { label: 'Bitte wählen', value: null },
    { label: 'Deutsch', value: 'Deutsch' },
    { label: 'Englisch', value: 'Englisch' },
    { label: 'Türkisch', value: 'Türkisch' },
    { label: 'Spanisch', value: 'Spanisch' },
    { label: 'Italienisch', value: 'Italienisch' },
    { label: 'Chinesisch', value: 'Chinesisch' },
    { label: 'Hindi', value: 'Hindi' },
    { label: 'Arabisch', value: 'Arabisch' },
    { label: 'Französisch', value: 'Französisch' },
    { label: 'Russisch', value: 'Russisch' },
    { label: 'Portugiesisch', value: 'Portugiesisch' },
    { label: 'Japanisch', value: 'Japanisch' },
    { label: 'Vietnamesisch', value: 'Vietnamesisch' },
    { label: 'Koreanisch', value: 'Koreanisch' },
    { label: 'Albanisch', value: 'Albanisch' },
    { label: 'Rumänisch', value: 'Rumänisch' },
    { label: 'Mazedonisch', value: 'Mazedonisch' },
    { label: 'Bulgarisch', value: 'Bulgarisch' },
    { label: 'Bosnisch', value: 'Bosnisch' },
    { label: 'Serbisch', value: 'Serbisch' },
    { label: 'Kroatisch', value: 'Kroatisch' },
    { label: 'Montenegrinisch', value: 'Montenegrinisch' },
    { label: 'Griechisch', value: 'Griechisch' },
    { label: 'Norwegisch', value: 'Norwegisch' },
    { label: 'Holländisch', value: 'Holländisch' },
    { label: 'Schwedisch', value: 'Schwedisch' },
    { label: 'Finnisch', value: 'Finnisch' }
  ],
  positions: [
    { label: 'PJler/in', value: 'PJ' },
    { label: 'Assistenzärztin/-arzt', value: 'Assistenzarzt' },
    { label: 'Fachärztin/-arzt', value: 'Facharzt' }
  ],
  perimeter: [
    {
      value: '',
      label: 'Umkreis',
      isDisabled: true
    },
    { value: [0, 10], label: '< 10 km' },
    { value: [10, 20], label: '< 20 km' },
    { value: [20, 30], label: '< 30 km' },
    { value: [30, 40], label: '< 40 km' },
    { value: [40, 50], label: '< 50 km' },
    { value: [50, 100], label: '< 100 km' },
    { value: [100, 200], label: '< 200 km' },
    { value: [50, 1000], label: 'bundesweit' }
  ],
  sex: [
    {
      value: '',
      label: 'Geschlecht',
      isDisabled: true
    },
    { value: 'm', label: 'männlich' },
    { value: 'w', label: 'weiblich' },
    { value: 'd', label: 'divers' }
  ],
  urgency: [
    {
      value: '',
      label: 'Dringlichkeit auswählen...',
      isDisabled: true
    },
    { value: true, label: 'Ich bin aktiv auf der Suche' },
    { value: false, label: 'Ich lasse mich gerne inspirieren' }
  ],
  clinicPraxis: [
    {
      value: '',
      label: 'Auswählen...',
      isDisabled: true
    },
    { value: 'clinic', label: 'Klinik' },
    { value: 'praxis', label: 'Praxis' }
  ],
  title: [
    {
      value: '',
      label: 'Auswählen...',
      isDisabled: true
    },
    { value: 'yes', label: 'Ja' },
    { value: 'no', label: 'Nein' },
    { value: 'almost', label: 'In den letzten Zügen' }
  ],
  salutation: [
    {
      value: '',
      label: 'Auswählen...',
      isDisabled: true
    },
    { value: 'Sehr geehrte Frau', label: 'Frau' },
    { value: 'Sehr geehrter Herr', label: 'Herr' }
  ],
  doc_title: [
    {
      value: '',
      label: 'kein Titel'
    },
    { value: 'Dr.', label: 'Dr.' },
    { value: 'Dr. med.', label: 'Dr. med.' },
    { value: 'Prof. Dr. med.', label: 'Prof. Dr. med.' },
    { value: 'Prof.', label: 'Prof.' }
  ],
  status: [
    {
      value: '',
      label: 'Auswählen...',
      isDisabled: true
    },
    { value: 'student', label: 'Student:in' },
    { value: 'pj', label: 'PJler:in' },
    { value: 'pjtoassi', label: 'zwischen PJ und Assist.' },
    { value: 'assi1', label: 'Assistent:in, 1. Jahr' },
    { value: 'assi2', label: 'Assistent:in, 2. Jahr' },
    { value: 'assi3', label: 'Assistent:in, 3. Jahr' },
    { value: 'assi4', label: 'Assistent:in, 4. Jahr' },
    { value: 'assi5', label: 'Assistent:in, 5. Jahr' },
    { value: 'assi6', label: 'Assistent:in, 6. Jahr' }
  ],
  workingTime: [
    {
      value: '',
      label: 'Arbeitszeit auswählen',
      isDisabled: true
    },
    ...Array.from(Array(100).keys()).map(i => {
      return { value: i + 1, label: i + 1 + ' %' };
    })
  ],
  years: [
    {
      value: '',
      label: 'Zeit',
      isDisabled: true
    },
    { value: [-1, -1], label: 'PJ' },
    { value: [0, 1], label: '<1 Jahr' },
    { value: [1, 2], label: '1-2 Jahre' },
    { value: [2, 3], label: '2-3 Jahre' },
    { value: [3, 4], label: '3-4 Jahre' },
    { value: [4, 5], label: '4-5 Jahre' },
    { value: [6, 100], label: '>5 Jahre' }
  ],
  languageExperience: [
    {
      value: '',
      label: 'Level',
      isDisabled: true
    },
    { value: 1, label: 'Muttersprache' },
    { value: 2, label: 'verhandlungssicher' },
    { value: 3, label: 'fließend' },
    { value: 4, label: 'gute Kenntnisse' },
    { value: 5, label: 'Grundkenntnisse' }
  ],
  tarif: [
    {
      value: '',
      label: 'Tarifvertrag',
      isDisabled: true
    },
    { value: '1', label: 'Tarif 1' }
  ],
  addressType: [
    {
      value: '',
      label: 'Adressen-Typ',
      isDisabled: true
    },
    { value: 'billing', label: 'Rechnungsadresse' },
    { value: 'main location', label: 'Hauptstandort' },
    { value: 'branch', label: 'Nebenstandort' }
  ],
  qualifications: [
    { label: 'Erfahrung Notaufnahme', value: 'Erfahrung Notaufnahme' },
    { label: 'Erfahrung Intensivstation', value: 'Erfahrung Intensivstation' },
    { label: 'Notarzt-Qualifikation', value: 'Notarzt-Qualifikation' },
    { label: 'Strahlenschutz-Kurs', value: 'Strahlenschutz-Kurs' }
  ]
};
